'use client';

import { createContext } from 'react';
import type { SheetPageKebabItem } from './SheetPageKebab';

export type SheetMode = 'modal' | 'sheet';

export interface ResponsiveSheetContextValue {
  /** Current display mode - 'modal' on desktop, 'sheet' on mobile */
  mode: SheetMode;
  /** The user's resolved theme ('light' or 'dark') */
  resolvedTheme: string | undefined;
  /** Navigate to a specific page */
  navigate: (page: string) => void;
  /** Go back to the previous page */
  goBack: () => void;
  /** Current page name */
  currentPage: string;
  /** Whether back navigation is available */
  canGoBack: boolean;
  /**
   * Push the synthetic actions page onto the sheet stack. Used by
   * `SheetPageKebab` in mobile sheet mode to drill into a row-style
   * action picker instead of opening a Radix dropdown over the sheet
   * (which violates Apple's "no popover over modal" rule and NN/g's
   * "don't stack bottom sheets" rule). Desktop modal mode keeps the
   * dropdown — call sites stay unaware of the split.
   */
  pushKebabPage: (items: SheetPageKebabItem[], title?: string) => void;
}

export const ResponsiveSheetContext = createContext<ResponsiveSheetContextValue | null>(null);
